import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';
import Typography from '@material-ui/core/Typography';
import { CALLCENTER_PLAN, restClient } from '../../../common';
import SelectReduxForm from '../../../components/SelectReduxForm';
import { refreshView as refreshViewAction } from 'react-admin';
import { QCD_STATUSES, QCD_RESULTS } from '../../../common';

import Timeline from "../../../components/MaterialDashboardPro/Timeline/Timeline";

const c = {
  headerElem: {
    fontSize: 14,
    fontFamily: 'Google Sans',
    color: "#212121",
    fontWeight: 300,
    marginRight: 35
  },
  headerElem2: {
    fontSize: 14,
    fontFamily: 'Google Sans',
    color: "#212121",
    fontWeight: 300,
    marginRight: 6
  },
  headerMore: {
    fontSize: 14,
    fontFamily: 'Google Sans',
    color: "#212121",
    fontWeight: 300,
    cursor: 'pointer',
    textDecoration: 'underline',
    // marginRight: 40
  },
  headerInfo: {
    marginTop: 13,
    marginBottom:20
  }
};

class EditComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feed: [],
      status: 'new'
    };
    restClient('GET_CUSTOM', 'clientGetFeed', {
      clientId: this.props.record.id,
    }).then(res => {
      this.setState({ feed: res.data });
    });
  }

  onSendComment = (type, comment, value = null) => {
    let sendData = {
      clientId: this.props.record.id,
      type: type,
      text: comment,
    };
    if (value !== null) {
      sendData.value = value;
    }
    restClient('GET_CUSTOM_POST', 'clientAddFeedItem', sendData).then(() => {
      restClient('GET_CUSTOM', 'clientGetFeed', {
        clientId: this.props.record.id,
      }).then(res => {
        this.setState({ feed: res.data});
      });
    });
  };

  onChangeForm = (values) => {
    restClient('GET_CUSTOM_POST', 'clients', values).then(res => {
      this.props.refreshView();
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.reduxFormUpdateToken !== this.props.reduxFormUpdateToken) {
      this.onChangeForm(this.props.formData.values);
    }
  }

  render() {
    let { handleSubmit, companies, callcenters, roles, record } = this.props;
    if (record === undefined) {
      record = {};
    }
    return (
      <div style={{
        width: '705px',
        backgroundColor: '#F9F9F9',
        padding: '60px 20px 10px 27px'
      }}>
        <h1>{record.name}</h1>
        <div style={c.headerInfo}>
          {record.phone && <span style={c.headerElem}>{record.phone}</span>}
          {record.email && <span style={c.headerElem}>{record.email}</span>}
          <span style={c.headerElem2}>Статус:</span>
          <Field name="status" component={SelectReduxForm} type="text" data-lpignore autoComplete="off" options={QCD_STATUSES}/>
          <span style={{...c.headerElem2, marginLeft: 35}}>Результат:</span>
          <Field name="result" component={SelectReduxForm} type="text" data-lpignore autoComplete="off" options={QCD_RESULTS}/>
        </div>
        <Timeline onlyComment={true} data={this.state.feed} onSendComment={this.onSendComment}/>
      </div>
    );
  }
}


let Edit = reduxForm({
  form: 'editClient'
})(EditComponent);

Edit = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
  formData: state.form.editClient,
  reduxFormUpdateToken: state.sc.reduxFormUpdateToken
}), {
  refreshView: refreshViewAction,
})(Edit);

export default Edit;



// WEBPACK FOOTER //
// ./src/pages/qcd/clients/EditClient.js